<div
    *ngIf="products?.length"
    [ngClass]="isGridView == 'true' ? 'gridView' : 'rowView'"
    class="col-gap"
    fxLayout="row wrap"
    fxLayoutAlign="none"
>
    <div
        class="card-container"
        [ngClass]="
            environmentVariables?.PRODUCT_CARD_STYLE == 'large'
                ? 'large-content'
                : ''
        "
        *ngFor="
            let product of products
                | paginate
                    : {
                          itemsPerPage: pageSize,
                          currentPage: currentPage,
                          totalItems: totalPage
                      };
            let i = index
        "
        fxFlex.lg="25"
        fxFlex.md="33.33"
        fxFlex.sm="50"
        fxFlex.xl="20"
        fxFlex.xs="{{
            environmentVariables?.SEARCH_PRODUCTS_THEME_TYPE == 'multi-products'
                ? 50
                : 100
        }}"
    >
        <ng-container *ngIf="isGridView != 'true'">
            <app-updated-product-card
                [viewLocation]="'search'"
                (addToCart)="addToCart($event)"
                *ngIf="product"
                [product]="product"
            >
            </app-updated-product-card>
        </ng-container>
        <mat-card class="card-item  card-item-border box-shadow-md" *ngIf="isGridView == 'true'">
            <div class="product-card">
                <div
                    class="chip-container d-flex flex-column"
                    [class.chip-ar]="lang == 'ar'"
                >
                    <mat-chip
                        *ngIf="
                            product?.discount_price !== null &&
                            product?.price &&
                            product?.in_stock &&
                            !product?.promotion &&
                            product?.price != product?.discount_price
                        "
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{
                            ((product?.price - product?.discount_price) /
                                product?.price) *
                                100 | number: "1.0-0"
                        }}
                        % 
                        <span  *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                          {{ "productDetails.off" | translate }}
                        </span>
                    </mat-chip>

                    <mat-chip
                        *ngIf="
                            product?.discount_price !== null &&
                            product?.price &&
                            product?.in_stock &&
                            product?.promotion
                        "
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        <ng-container *ngIf="lang == 'en'">
                            {{ product?.promotion_en }} OR
                            {{
                                ((product?.price - product?.discount_price) /
                                    product?.price) *
                                    100 | number: "1.0-0"
                            }}
                            %
                            <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                              {{ "productDetails.off" | translate }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="lang == 'ar'">
                            {{ product?.promotion_ar }} أو خصم
                            {{
                                ((product?.price - product?.discount_price) /
                                    product?.price) *
                                    100 | number: "1.2-2"
                            }}
                            %
                        </ng-container>
                    </mat-chip>

                    <mat-chip
                        *ngIf="product?.preorder"
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ "productDetails.preorder" | translate }}
                    </mat-chip>

                    <mat-chip
                        *ngIf="product?.available_soon"
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ "productDetails.availableSoon" | translate }}
                    </mat-chip>

                    <mat-chip
                        *ngIf="
                            product?.promos?.length &&
                            product?.promos[0]?.show_in_product != 0
                        "
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ product?.promos[0]?.name }}
                    </mat-chip>

                    <mat-chip
                        *ngIf="product?.promotion && !product?.direct_discount"
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ product?.promotion }}
                    </mat-chip>

                    <mat-chip
                        *ngIf="product?.type === 2"
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ "productDetails.bundle" | translate }}
                    </mat-chip>
                    <mat-chip
                        *ngIf="
                            product?.commission_amount &&
                            user?.is_affiliate &&
                            product?.commission_amount != 0
                        "
                        class="chip-commission-amount my-1"
                        tabindex="-1"
                    >
                        {{ "orders.commission" | translate }} :
                        {{ product?.commission_amount }}
                        {{
                            lang == "en"
                                ? environmentVariables.CURRENCY_CODE_EN
                                : environmentVariables.CURRENCY_CODE_AR
                        }}
                    </mat-chip>

                    <mat-chip
                        *ngIf="!product?.in_stock"
                        class="chip-item my-1"
                        tabindex="-1"
                    >
                        {{ "home_Page.outOfStouck" | translate }}
                    </mat-chip>
                </div>
                <!-- [queryParams]="{ variant: product?.id }" -->
                <a
                    *ngIf="environmentVariables?.PRODUCT_TYPE != 'main'"
                   
                    (click)="googleAnalaticSelectItem(product)"
                    [routerLink]="[
                        '/' + lang + '/' +
                        product?.slug
                    ]"
                    class="p-link image-container"
                    style="outline: none !important; position: relative"
                >
                    <div
                        class="img-brand"
                        [ngClass]="{
                            'left-0': lang == 'ar',
                            'right-0': lang == 'en'
                        }"
                        *ngIf="
                            product?.brand &&
                            environmentVariables?.SHOW_BRAND_ON_PRODUCT
                        "
                    >
                        <img loading="lazy" [src]="product?.brand.image" alt="product brand image" />
                    </div>
                    <img loading="lazy" 
                        [src]="product?.image"
                        [alt]="product?.name"
                        class="card-img image-default d-md-block d-none"
                        default="./assets/images/placeholder200.jpg"
                        height="800"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        width="626"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />
                    <img loading="lazy" 
                        [src]="product?.image"
                        [alt]="product?.name"
                        class="card-img image-default d-md-none d-block card-img-mobile-view"
                        default="./assets/images/placeholder200.jpg"
                        height="800"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        width="626"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />

                    <img  loading="lazy" 
                        [src]="product?.images[0]?.url || product?.image"
                           [alt]="product?.name"
                        class="image-hover card-img-mobile-view card-img"
                        default="./assets/images/placeholder200.jpg"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />
                </a>
                <a
                    *ngIf="environmentVariables?.PRODUCT_TYPE == 'main'"
                 
                    (click)="googleAnalaticSelectItem(product)"
                    [routerLink]="[
                        '/' + lang + '/' +
                         product?.product_variants[0]?.slug
                    ]"
                    class="p-link image-container"
                    style="outline: none !important"
                >
                    <img  loading="lazy" 
                        [src]="product?.image"
                           [alt]="product?.name"
                        class="card-img image-default web-view"
                        default="./assets/images/placeholder200.jpg"
                        height="800"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        width="626"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />
                    <img  loading="lazy" 
                        [src]="product?.image"
                           [alt]="product?.name"
                        class="card-img image-default mobile-view card-img-mobile-view"
                        default="./assets/images/placeholder200.jpg"
                        height="800"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        width="626"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />

                    <img  loading="lazy" 
                        [src]="product?.images[0]?.url || product?.image"
                           [alt]="product?.name"
                        class="image-hover card-img-mobile-view card-img"
                        default="./assets/images/placeholder200.jpg"
                        mat-card-image
                        onError="this.src='./assets/images/placeholder200.jpg';"
                        [ngClass]="
                            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                                ? 'bigImg'
                                : ''
                        "
                    />
                </a>
                <mat-card-content class="product-content">
                    <div>
                        <div
                            class="product-title mb-0"
                            style="font-family: Roboto, sans-serif !important"
                        >
                            <ng-container *ngIf="isGridView == 'false'">
                                <div
                                    class="titel-advanced-theme row-min-width"
                                    [ngClass]="
                                        environmentVariables?.SHOW_CATEGORY_ON_PRODUCT_CARD &&
                                        product?.brand &&
                                        environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                            ? 'row-min-width'
                                            : ''
                                    "
                                >
                                    <span
                                        class="category-item itemCategory"
                                        *ngIf="
                                            environmentVariables?.SHOW_CATEGORY_ON_PRODUCT_CARD
                                        "
                                    >
                                        {{
                                            lang === "en"
                                                ? product?.category?.name
                                                : product?.category?.name_ar
                                        }}
                                        <ng-container
                                            *ngIf="product?.optional_category"
                                            >,
                                            {{
                                                lang === "en"
                                                    ? product?.optional_category
                                                          ?.name
                                                    : product?.optional_category
                                                          ?.name_ar
                                            }}</ng-container
                                        >
                                    </span>
                                    <!-- <a
                                        *ngIf="
                                            environmentVariables?.PRODUCT_TYPE ==
                                            'main'
                                        "
                                        (click)="
                                            googleAnalaticSelectItem(product)
                                        "
                                        [routerLink]="[
                                            '/' + lang + '/products',
                                            product?.routingName,
                                            product?.id
                                        ]"
                                        class="title-link"
                                        style="
                                            outline: none;
                                            font-weight: 700 !important;
                                        "
                                        >{{ product?.name }}
                                    </a> -->
                                </div>
                            </ng-container>
                            <ng-container>
                              <!-- [queryParams]="{ variant: product?.id }" -->
                                <a
                                    *ngIf="
                                        environmentVariables?.PRODUCT_TYPE !=
                                        'main'
                                    "
                                    (click)="googleAnalaticSelectItem(product)"
                                    [routerLink]="[
                                        '/' + lang + '/' +
                                        product?.slug
                                    ]"
                                    class="title-link"
                                    style="outline: none"
                                    >{{
                                        lang == "ar"
                                            ? product?.name_ar
                                            : product?.name_en
                                    }}
                                </a>
                                <!-- [queryParams]="{
                                  variant:
                                      product?.product_variants[0]?.id
                              }" -->
                                <a
                                    *ngIf="
                                        environmentVariables?.PRODUCT_TYPE ==
                                        'main'
                                    "
                                 
                                    (click)="googleAnalaticSelectItem(product)"
                                    [routerLink]="[
                                        '/' + lang + '/' + product?.product_variants[0]?.slug
                                    ]"
                                    class="title-link"
                                    style="outline: none"
                                    >{{ product?.name }}
                                </a>
                                <span class="product-category">
                                    <span
                                        class="grid-view-display"
                                        style="display: none; font-size: 14px"
                                    >
                                        {{
                                            lang === "en"
                                                ? product?.category?.name
                                                : product?.category?.name_ar
                                        }}
                                        <ng-container
                                            *ngIf="product?.optional_category"
                                            >,
                                            {{
                                                lang === "en"
                                                    ? product?.optional_category
                                                          ?.name
                                                    : product?.optional_category
                                                          ?.name_ar
                                            }}</ng-container
                                        >
                                    </span>
                                    <span
                                        class="grid-view-display material-icons-arrow"
                                        style="display: none"
                                    >
                                        <mat-icon class="material-icons">
                                            {{
                                                lang === "en"
                                                    ? "keyboard_arrow_right"
                                                    : "keyboard_arrow_left"
                                            }}
                                        </mat-icon>
                                    </span>
                                    <span
                                        class="grid-view-display"
                                        style="display: none; font-size: 14px"
                                    >
                                        {{
                                            lang === "en"
                                                ? product?.category
                                                      ?.sub_categories[0].name
                                                : product?.category
                                                      ?.sub_categories[0]
                                                      .name_ar
                                        }}
                                    </span>
                                </span>
                                <div class="d-flex rate-container"  
                                *ngIf="environmentVariables?.ENABLE_PRODUCT_RATE"  
                                  [ngClass]=" lang == 'ar'? 'direction-ar': ''">
                                  <bar-rating [rate]="product?.rate" [max]="5" [readOnly]="true"></bar-rating>
                                    <div style="font-size: 18px;" class="mx-2 mt-1">
                                     <span class="">{{getRate(product)}}</span> <span>{{ '(' + product?.rate_count + ')' }}</span>  
                                    </div>
                                </div>
                            </ng-container>
                            <!--Case In Mobile With RowView[Grid]-->
                            <div
                                *ngIf="isGridView == 'true'"
                                class="d-flex mobile-view flex-column justify-start my-1 row-min-width"
                                [ngClass]="
                                    product?.brand &&
                                    environmentVariables?.SHOW_BRAND_ON_PRODUCT
                                        ? 'row-min-width'
                                        : ''
                                "
                            >
                                <div class="price w-100 my-0">
                                    <ng-container>
                                        <div
                                            class="price-view flex-column"
                                            [ngClass]="
                                                environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE
                                                    ? 'discount-two-lines'
                                                    : ''
                                            "
                                        >
                                            <del
                                                style="
                                                    font-size: 13px !important;
                                                "
                                                *ngIf="
                                                    product?.discount_price !==
                                                        null &&
                                                    (product?.in_stock ||
                                                        environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
                                                    product?.price !=
                                                        product?.discount_price
                                                "
                                                [ngClass]="{
                                                    'config-price-after-discount':
                                                        product?.discount_price &&
                                                        environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                    'config-price-color':
                                                        environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                    'defult-price-color-after-discount':
                                                        !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                        product?.discount_price,
                                                    'price-ar': lang == 'ar'
                                                }"
                                            >
                                                {{ product?.price
                                                }}{{
                                                    lang == "en"
                                                        ? environmentVariables.CURRENCY_CODE_EN
                                                        : environmentVariables.CURRENCY_CODE_AR
                                                }}
                                            </del>

                                            <span
                                                *ngIf="
                                                    product?.price !== null &&
                                                    (product?.in_stock ||
                                                        environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE)
                                                "
                                                [ngClass]="{
                                                    'price-ar': lang == 'ar',
                                                    'config-price-before-discount':
                                                        product?.discount_price &&
                                                        environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                    'config-price-color':
                                                        environmentVariables?.PRODUCT_PRICE_TEXT_COLOR &&
                                                        !product?.discount_price
                                                }"
                                                class="mx-1 w-100 payment-with-discount-container defult-price-color d-flex"
                                                style="
                                                    justify-content: center;
                                                    font-family: Roboto,
                                                        sans-serif !important;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{
                                                    product?.discount_price !==
                                                    null
                                                        ? product?.discount_price
                                                        : product?.price
                                                }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables.CURRENCY_CODE_EN
                                                        : environmentVariables.CURRENCY_CODE_AR
                                                }}
                                                <span
                                                    *ngIf="
                                                        environmentVariables?.ENABLE_INCLUDING_VAT
                                                    "
                                                    class="inc-vat"
                                                >
                                                    {{ "IncVAT" | translate }}
                                                </span>

                                                <div
                                                    class="discount-method-information"
                                                    *ngIf="
                                                        product?.payment_methods_discount_name_en
                                                    "
                                                >
                                                    <p>i</p>
                                                    <div class="hover-info">
                                                        {{
                                                            lang == "en"
                                                                ? product?.payment_methods_discount_name_en
                                                                : product?.payment_methods_discount_name_ar
                                                        }}
                                                    </div>
                                                </div>
                                            </span>

                                            <span
                                                *ngIf="product?.available_soon"
                                                [ngClass]="
                                                    isGridView == 'true'
                                                        ? 'text-center'
                                                        : ''
                                                "
                                                class="out-of-stock"
                                            >
                                                {{
                                                    "productDetails.availableSoon"
                                                        | translate
                                                }}
                                            </span>
                                            <span
                                                [ngClass]="
                                                    lang == 'en'
                                                        ? ''
                                                        : 'price-ar'
                                                "
                                                class="up-to"
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        product?.variant_max_price &&
                                                        ((product?.discount_price &&
                                                            product?.variant_max_price >
                                                                product?.discount_price) ||
                                                            (!product?.discount_price &&
                                                                product?.variant_max_price >
                                                                    product?.price))
                                                    "
                                                >
                                                    {{
                                                        lang == "en"
                                                            ? " up to "
                                                            : " حتى "
                                                    }}{{
                                                        product?.variant_max_price
                                                    }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}</ng-container
                                                >
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                                <ng-container
                                    *ngIf="
                                        environmentVariables?.PRODUCT_TYPE ==
                                            'main' &&
                                        environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS
                                    "
                                >
                                    <div
                                        class="image-gallary-container"
                                        *ngIf="
                                            product?.product_variants_options &&
                                                product
                                                    ?.product_variants_options
                                                    .length > 0;
                                            else singleImageGallery
                                        "
                                    >
                                        <div
                                            class="gallery-image"
                                            *ngFor="
                                                let value of product?.product_variants_options[0].values.slice(
                                                    0,
                                                    variantsLimit
                                                )
                                            "
                                            (mouseenter)="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '3' ||
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '4'
                                                    ? setChossenData(
                                                          product,
                                                          value.id
                                                      )
                                                    : ''
                                            "
                                            (mouseleave)="
                                                originalImage(product)
                                            "
                                            [class.text-box]="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '1'
                                            "
                                            [class.color-box]="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '2'
                                            "
                                            [class.image-box]="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '3' ||
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '4'
                                            "
                                            [style.background-color]="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '2'
                                                    ? value?.color_code
                                                    : 'transparent'
                                            "
                                            [style.border]="
                                                product
                                                    ?.product_variants_options[0]
                                                    ?.option?.type == '2'
                                                    ? '1px solid #000'
                                                    : ''
                                            "
                                        >
                                            <span
                                                *ngIf="
                                                    product
                                                        ?.product_variants_options[0]
                                                        .option?.type == '1'
                                                "
                                                style="
                                                    font-size: 12px;
                                                    line-height: 1;
                                                "
                                                >{{ value?.name }}</span
                                            >
                                            <span
                                                *ngIf="
                                                    product
                                                        ?.product_variants_options[0]
                                                        .option?.type == '2'
                                                "
                                            ></span>
                                            <img  loading="lazy" 
                                                *ngIf="
                                                    product
                                                        ?.product_variants_options[0]
                                                        .option?.type == '3' ||
                                                    product
                                                        ?.product_variants_options[0]
                                                        .option?.type == '4' ||
                                                    value?.image
                                                "
                                                [src]="value.image"
                                                   alt="image"
                                                onError="this.src='./assets/images/placeholder200.jpg';"
                                                default="./assets/images/placeholder200.jpg"
                                            />
                                        </div>
                                        <a
                                            *ngIf="
                                                product
                                                    ?.product_variants_options[0]
                                                    .values.length >
                                                variantsLimit
                                            "
                                            class="gallery-image plus-variants"
                                        >
                                            +{{
                                                product
                                                    ?.product_variants_options[0]
                                                    .values.length -
                                                    variantsLimit
                                            }}
                                        </a>
                                    </div>
                                    <ng-template #singleImageGallery>
                                        <div class="image-gallary-container">
                                            <div class="gallery-image">
                                                <img  loading="lazy" 
                                                    [src]="product?.image"
                                                    onError="this.src='./assets/images/placeholder70.png';"
                                                       alt="photo gallery item"
                                                />
                                            </div>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </div>
                        <ul
                            class="product-tags"
                            style="display: none !important"
                        >
                            <li
                                *ngFor="
                                    let tag of product?.product_variants_options
                                "
                                class="product-tag"
                            >
                                {{ tag.values[0]?.name }}
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="!product?.id">
                        <p class="product-title mb-0">
                          <!-- [queryParams]="{ variant: product?.id }" -->
                            <a
                                *ngIf="
                                    environmentVariables?.PRODUCT_TYPE != 'main'
                                "
                                (click)="googleAnalaticSelectItem(product)"
                                [routerLink]="[
                                    '/' + lang + '/' +
                                    product?.slug
                                ]"
                                class="title-link"
                                style="outline: none"
                                >{{
                                    lang == "ar"
                                        ? product?.name_ar
                                        : product?.name_en
                                }}
                            </a>
                            <a
                                *ngIf="
                                    environmentVariables?.PRODUCT_TYPE == 'main'
                                "
                                (click)="googleAnalaticSelectItem(product)"
                                [routerLink]="[
                                    '/' + lang + '/' +
                                    product?.slug
                                ]"
                                class="title-link"
                                style="outline: none"
                                >{{
                                    lang == "ar"
                                        ? product?.name_ar
                                        : product?.name_en
                                }}
                            </a>
                        </p>
                    </div>
                    <div class="card_info">
                        <ng-container *ngIf="isGridView == 'true'">
                            <div
                                class="price-container w-100 justify-center web-view mb-0"
                            >
                                <div class="price w-100">
                                    <p
                                        class="price w-100 price-text"
                                        style="
                                            margin-bottom: 0px;
                                            margin-top: 0px;
                                        "
                                    >
                                        <ng-container
                                            *ngIf="
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                        >
                                            <div class="price-view">
                                                <del
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    class="text-center"
                                                    *ngIf="
                                                        product?.discount_price !==
                                                            null &&
                                                        (product?.in_stock ||
                                                            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
                                                        product?.price !=
                                                            product?.discount_price
                                                    "
                                                    [ngClass]="{
                                                        'config-price-after-discount':
                                                            product?.discount_price &&
                                                            environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                        'config-price-color':
                                                            environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                        'defult-price-color-after-discount':
                                                            !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                            product?.discount_price,
                                                        'price-ar': lang == 'ar'
                                                    }"
                                                >
                                                    {{ product?.price }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}
                                                </del>

                                                <span
                                                    *ngIf="
                                                        product?.price !==
                                                            null &&
                                                        (product?.in_stock ||
                                                            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE)
                                                    "
                                                    [ngClass]="{
                                                        'price-ar':
                                                            lang == 'ar',
                                                        'config-price-before-discount':
                                                            product?.discount_price &&
                                                            environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                        'config-price-color':
                                                            environmentVariables?.PRODUCT_PRICE_TEXT_COLOR &&
                                                            !product?.discount_price
                                                    }"
                                                    class="mx-1 w-100 payment-with-discount-container defult-price-color d-flex"
                                                    style="
                                                        font-family: Roboto,
                                                            sans-serif !important;
                                                        font-weight: bold;
                                                    "
                                                >
                                                    {{
                                                        product?.discount_price !==
                                                        null
                                                            ? product?.discount_price
                                                            : product?.price
                                                    }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}
                                                    <span
                                                        *ngIf="
                                                            environmentVariables?.ENABLE_INCLUDING_VAT
                                                        "
                                                        class="inc-vat"
                                                    >
                                                        {{
                                                            "IncVAT" | translate
                                                        }}
                                                    </span>

                                                    <div
                                                        class="discount-method-information grid-view"
                                                        *ngIf="
                                                            product?.payment_methods_discount_name_en
                                                        "
                                                    >
                                                        <p>i</p>
                                                        <div class="hover-info">
                                                            {{
                                                                lang == "en"
                                                                    ? product?.payment_methods_discount_name_en
                                                                    : product?.payment_methods_discount_name_ar
                                                            }}
                                                        </div>
                                                    </div>
                                                </span>

                                                <span
                                                    *ngIf="
                                                        product?.available_soon
                                                    "
                                                    [ngClass]="
                                                        isGridView == 'true'
                                                            ? 'text-center'
                                                            : ''
                                                    "
                                                    class="out-of-stock"
                                                >
                                                    {{
                                                        "productDetails.availableSoon"
                                                            | translate
                                                    }}
                                                </span>
                                            </div>
                                            <span
                                                [ngClass]="
                                                    lang == 'en'
                                                        ? ''
                                                        : 'price-ar'
                                                "
                                                class="up-to"
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        product?.variant_max_price &&
                                                        ((product?.discount_price &&
                                                            product?.variant_max_price >
                                                                product?.discount_price) ||
                                                            (!product?.discount_price &&
                                                                product?.variant_max_price >
                                                                    product?.price))
                                                    "
                                                >
                                                    {{
                                                        lang == "en"
                                                            ? " up to "
                                                            : " حتى "
                                                    }}{{
                                                        product?.variant_max_price
                                                    }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}</ng-container
                                                >
                                            </span>
                                        </ng-container>
                                    </p>
                                </div>
                                <div class="rating-star">
                                    <embryo-Rating
                                        [rate]="product?.rating"
                                    ></embryo-Rating>
                                </div>
                            </div>
                            <ng-container
                                *ngIf="
                                    environmentVariables?.PRODUCT_TYPE ==
                                        'main' &&
                                    environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS
                                "
                            >
                                <div
                                    class="image-gallary-container"
                                    *ngIf="
                                        product?.product_variants_options &&
                                            product?.product_variants_options
                                                .length > 0;
                                        else singleImageGallery
                                    "
                                >
                                    <div
                                        class="gallery-image"
                                        *ngFor="
                                            let value of product?.product_variants_options[0].values.slice(
                                                0,
                                                variantsLimit
                                            )
                                        "
                                        [class.text-box]="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '1'
                                        "
                                        [class.color-box]="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '2'
                                        "
                                        [class.image-box]="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '3' ||
                                            product?.product_variants_options[0]
                                                ?.option?.type == '4'
                                        "
                                        [style.background-color]="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '2'
                                                ? value?.color_code
                                                : 'transparent'
                                        "
                                        [style.border]="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '2'
                                                ? '1px solid #000'
                                                : ''
                                        "
                                        (mouseenter)="
                                            product?.product_variants_options[0]
                                                ?.option?.type == '3' ||
                                            product?.product_variants_options[0]
                                                ?.option?.type == '4'
                                                ? setChossenData(
                                                      product,
                                                      value.id
                                                  )
                                                : ''
                                        "
                                    >
                                        <span
                                            *ngIf="
                                                product
                                                    ?.product_variants_options[0]
                                                    .option?.type == '1'
                                            "
                                            style="
                                                font-size: 12px;
                                                line-height: 1;
                                            "
                                            >{{ value?.name }}</span
                                        >
                                        <span
                                            *ngIf="
                                                product
                                                    ?.product_variants_options[0]
                                                    .option?.type == '2'
                                            "
                                        ></span>
                                        <img  loading="lazy" 
                                            *ngIf="
                                                product
                                                    ?.product_variants_options[0]
                                                    .option?.type == '3' ||
                                                product
                                                    ?.product_variants_options[0]
                                                    .option?.type == '4' ||
                                                value?.image
                                            "
                                            [src]="value.image"
                                               alt="image"
                                            onError="this.src='./assets/images/placeholder200.jpg';"
                                            default="./assets/images/placeholder200.jpg"
                                        />
                                    </div>
                                    <a
                                        *ngIf="
                                            product?.product_variants_options[0]
                                                .values.length > variantsLimit
                                        "
                                        class="gallery-image plus-variants"
                                    >
                                        +{{
                                            product?.product_variants_options[0]
                                                .values.length - variantsLimit
                                        }}
                                    </a>
                                </div>
                                <ng-template #singleImageGallery>
                                    <div class="image-gallary-container">
                                        <div class="gallery-image">
                                            <img  loading="lazy" 
                                                [src]="product?.image"
                                                onError="this.src='./assets/images/placeholder70.png';"
                                                   alt="photo gallery item"
                                            />
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="isGridView == 'false'">
                            <div
                                class="price-container mb-0"
                                fxFlex
                                fxLayoutAlign="space-between"
                            >
                                <div
                                    class="price w-100"
                                    fxLayoutAlign="space-between"
                                >
                                    <p
                                        class="price w-100 price-text mx-0"
                                        [ngStyle]="{
                                            'max-height':
                                                environmentVariables?.PRODUCT_TYPE ==
                                                'main'
                                                    ? '130px'
                                                    : '150px'
                                        }"
                                    >
                                        <ng-container>
                                            <div class="price-view">
                                                <del
                                                    style="
                                                        font-size: 13px !important;
                                                    "
                                                    *ngIf="
                                                        product?.discount_price !==
                                                            null &&
                                                        (product?.in_stock ||
                                                            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
                                                        product?.price !=
                                                            product?.discount_price
                                                    "
                                                    [ngClass]="{
                                                        'config-price-after-discount':
                                                            product?.discount_price &&
                                                            environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                        'config-price-color':
                                                            environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                        'defult-price-color-after-discount':
                                                            !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                            product?.discount_price,
                                                        'price-ar': lang == 'ar'
                                                    }"
                                                >
                                                    {{ product?.price }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}
                                                </del>

                                                <span
                                                    [ngClass]="{
                                                        'price-ar':
                                                            lang == 'ar',
                                                        'config-price-before-discount':
                                                            product?.discount_price &&
                                                            environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                        'config-price-color':
                                                            environmentVariables?.PRODUCT_PRICE_TEXT_COLOR &&
                                                            !product?.discount_price
                                                    }"
                                                    class="mx-1 w-100 payment-with-discount-container defult-price-color d-flex"
                                                    style="
                                                        min-height: 27px;
                                                        font-family: Roboto,
                                                            sans-serif !important;
                                                        font-weight: bold;
                                                    "
                                                >
                                                    <ng-container
                                                        *ngIf="
                                                            product?.price !==
                                                                null &&
                                                                (product?.in_stock ||
                                                                    environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE);
                                                            else noPrice
                                                        "
                                                    >
                                                        {{
                                                            product?.discount_price !==
                                                            null
                                                                ? product?.discount_price
                                                                : product?.price
                                                        }}
                                                        {{
                                                            lang == "en"
                                                                ? environmentVariables.CURRENCY_CODE_EN
                                                                : environmentVariables.CURRENCY_CODE_AR
                                                        }}
                                                        <div
                                                            class="discount-method-information"
                                                            *ngIf="
                                                                product?.payment_methods_discount_name_en
                                                            "
                                                        >
                                                            <p>i</p>
                                                            <div
                                                                class="hover-info"
                                                            >
                                                                {{
                                                                    lang == "en"
                                                                        ? product?.payment_methods_discount_name_en
                                                                        : product?.payment_methods_discount_name_ar
                                                                }}
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #noPrice>
                                                        <span
                                                            style="
                                                                height: 120px;
                                                            "
                                                            >{{
                                                                noPricecontent
                                                            }}</span
                                                        >
                                                    </ng-template>
                                                </span>
                                            </div>
                                            <span
                                                [ngClass]="
                                                    lang == 'en'
                                                        ? ''
                                                        : 'price-ar'
                                                "
                                                class="up-to"
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        product?.variant_max_price &&
                                                        product?.variant_max_price >
                                                            product?.price &&
                                                        product?.variant_max_price >
                                                            product?.discount_price
                                                    "
                                                >
                                                    {{
                                                        lang == "en"
                                                            ? " up to "
                                                            : " حتى "
                                                    }}{{
                                                        product?.variant_max_price
                                                    }}
                                                    {{
                                                        lang == "en"
                                                            ? environmentVariables.CURRENCY_CODE_EN
                                                            : environmentVariables.CURRENCY_CODE_AR
                                                    }}</ng-container
                                                >
                                            </span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="
                                                environmentVariables?.PRODUCT_TYPE ==
                                                    'main' &&
                                                environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS
                                            "
                                        >
                                            <div
                                                class="image-gallary-container"
                                                *ngIf="
                                                    product?.product_variants_options &&
                                                        product
                                                            ?.product_variants_options
                                                            .length > 0;
                                                    else singleImageGallery
                                                "
                                            >
                                                <div
                                                    class="gallery-image"
                                                    [class.text-box]="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                        '1'
                                                    "
                                                    [class.color-box]="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                        '2'
                                                    "
                                                    [class.image-box]="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                            '3' ||
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                            '4'
                                                    "
                                                    [style.background-color]="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                        '2'
                                                            ? value?.color_code
                                                            : 'transparent'
                                                    "
                                                    [style.border]="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                        '2'
                                                            ? '1px solid #000'
                                                            : ''
                                                    "
                                                    *ngFor="
                                                        let value of product?.product_variants_options[0].values.slice(
                                                            0,
                                                            variantsLimit
                                                        )
                                                    "
                                                    (mouseenter)="
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                            '3' ||
                                                        product
                                                            ?.product_variants_options[0]
                                                            ?.option?.type ==
                                                            '4'
                                                            ? setChossenData(
                                                                  product,
                                                                  value.id
                                                              )
                                                            : ''
                                                    "
                                                >
                                                    <span
                                                        *ngIf="
                                                            product
                                                                ?.product_variants_options[0]
                                                                .option?.type ==
                                                            '1'
                                                        "
                                                        style="
                                                            font-size: 12px;
                                                            line-height: 1;
                                                        "
                                                        >{{ value?.name }}</span
                                                    >
                                                    <span
                                                        *ngIf="
                                                            product
                                                                ?.product_variants_options[0]
                                                                .option?.type ==
                                                            '2'
                                                        "
                                                    ></span>
                                                    <img  loading="lazy" 
                                                        *ngIf="
                                                            product
                                                                ?.product_variants_options[0]
                                                                .option?.type ==
                                                                '3' ||
                                                            product
                                                                ?.product_variants_options[0]
                                                                .option?.type ==
                                                                '4' ||
                                                            value?.image
                                                        "
                                                        [src]="value.image"
                                                           alt="iamge"
                                                        onError="this.src='./assets/images/placeholder200.jpg';"
                                                        default="./assets/images/placeholder200.jpg"
                                                    />
                                                </div>
                                                <a
                                                    *ngIf="
                                                        product
                                                            ?.product_variants_options[0]
                                                            .values.length >
                                                        variantsLimit
                                                    "
                                                    class="gallery-image plus-variants"
                                                >
                                                    +{{
                                                        product
                                                            ?.product_variants_options[0]
                                                            .values.length -
                                                            variantsLimit
                                                    }}
                                                </a>
                                            </div>
                                            <ng-template #singleImageGallery>
                                                <div
                                                    class="image-gallary-container"
                                                >
                                                    <div class="gallery-image">
                                                        <img  loading="lazy" 
                                                            [src]="
                                                                product?.image
                                                            "
                                                            onError="this.src='./assets/images/placeholder70.png';"
                                                               alt="photo gallery item"
                                                        />
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                    </p>
                                </div>
                                <div class="rating-star">
                                    <embryo-Rating
                                        [rate]="product?.rating"
                                    ></embryo-Rating>
                                </div>
                            </div>
                        </ng-container>

                        <mat-card-footer
                            *ngIf="isGridView == 'true'"
                            style="margin-top: 0"
                        >
                            <div
                                class="actions-wrapper web-view w-100"
                                fxLayoutAlign="space-between center"
                            >
                                <div
                                    class="card-actions"
                                    [class.card-actions-grid]="
                                        !product?.in_stock
                                    "
                                >
                                    <button
                                        (click)="
                                            addToFavouriteList(
                                                environmentVariables?.PRODUCT_TYPE ==
                                                    'main'
                                                    ? product
                                                          ?.product_variants[0]
                                                    : product,
                                                environmentVariables?.PRODUCT_TYPE
                                            )
                                        "
                                        class="favorite-icon-container favorite-footer-btn pointer p-0"
                                    >
                                        <mat-icon
                                            [class.left-fav]="lang == 'ar'"
                                            [ngClass]="{
                                                'wishlist-active':
                                                    product?.is_favourite ==
                                                        true ||
                                                    product?.product_variants[0]
                                                        ?.is_favourite,
                                                'right-5': lang == 'en',
                                                'left-5': lang == 'ar',
                                                'top-icon':
                                                    environmentVariables?.FAVORITE_ICON_POSITION ==
                                                    'top'
                                            }"
                                            class="material-icons favorite pointer"
                                        >
                                            favorite
                                        </mat-icon>
                                        <div
                                            class="loader-container"
                                            *ngIf="product?.favouriteLoading"
                                        >
                                            <app-loading></app-loading>
                                        </div>
                                    </button>

                                    <button
                                        *ngIf="
                                            !environmentVariables?.DISABLE_COMPARE
                                        "
                                        (click)="
                                            addToCompareList(
                                                environmentVariables?.PRODUCT_TYPE ==
                                                    'main'
                                                    ? product
                                                          ?.product_variants[0]
                                                    : product
                                            )
                                        "
                                        [disabled]="product?.compareLoading"
                                        [style.cursor]="
                                            product?.compareLoading
                                                ? 'not-allowed'
                                                : 'pointer'
                                        "
                                        title="Compare"
                                        class="compare-icon-container p-0"
                                    >
                                        <mat-icon
                                            *ngIf="!product?.compareLoading"
                                            [class.compare-active]="
                                                product?.is_compare ||
                                                product?.product_variants[0]
                                                    ?.is_compare
                                            "
                                            class="material-icons favorite"
                                        >
                                            compare
                                        </mat-icon>
                                        <div
                                            class="loader-container"
                                            *ngIf="product?.compareLoading"
                                        >
                                            <app-loading></app-loading>
                                        </div>
                                    </button>
                                </div>

                                <!--Regular Product-->
                                <div class="text-center">
                                    <app-control-add-to-cart
                                        *ngIf="product"
                                        [product]="product"
                                        [styleCard]="true"
                                        [isGridView]="isGridView"
                                        [redirectToProduct]="redirectToProduct"
                                    >
                                    </app-control-add-to-cart>
                                </div>
                            </div>
                        </mat-card-footer>

                        <mat-card-footer
                            *ngIf="isGridView == 'false'"
                            style="
                                margin-top: auto;
                                height: 65px !important;
                                padding-top: 16px;
                            "
                        >
                            <div
                                class="actions-wrapper w-100"
                                fxLayoutAlign="space-between center"
                            >
                                <div class="card-actions">
                                    <button
                                        (click)="
                                            addToFavouriteList(
                                                environmentVariables?.PRODUCT_TYPE ==
                                                    'main'
                                                    ? product
                                                          ?.product_variants[0]
                                                    : product,
                                                environmentVariables?.PRODUCT_TYPE
                                            )
                                        "
                                        class="favorite-icon-container favorite-footer-btn pointer p-0"
                                    >
                                        <mat-icon
                                            [class.left-fav]="lang == 'ar'"
                                            [ngClass]="{
                                                'wishlist-active':
                                                    product?.is_favourite ==
                                                        true ||
                                                    product?.product_variants[0]
                                                        ?.is_favourite,
                                                'right-5': lang == 'en',
                                                'left-5': lang == 'ar',
                                                'top-icon':
                                                    environmentVariables?.FAVORITE_ICON_POSITION ==
                                                    'top'
                                            }"
                                            class="material-icons favorite pointer"
                                        >
                                            favorite
                                        </mat-icon>
                                        <div
                                            class="loader-container"
                                            *ngIf="product?.favouriteLoading"
                                        >
                                            <app-loading></app-loading>
                                        </div>
                                    </button>

                                    <button
                                        *ngIf="
                                            product?.in_stock &&
                                            !environmentVariables?.DISABLE_COMPARE
                                        "
                                        (click)="
                                            addToCompareList(
                                                environmentVariables?.PRODUCT_TYPE ==
                                                    'main'
                                                    ? product
                                                          ?.product_variants[0]
                                                    : product
                                            )
                                        "
                                        [disabled]="product?.compareLoading"
                                        [style.cursor]="
                                            product?.compareLoading
                                                ? 'not-allowed'
                                                : 'pointer'
                                        "
                                        title="Compare"
                                        class="compare-icon-container p-0"
                                    >
                                        <mat-icon
                                            *ngIf="!product?.compareLoading"
                                            [class.compare-active]="
                                                product?.is_compare ||
                                                product?.product_variants[0]
                                                    ?.is_compare
                                            "
                                            class="material-icons favorite p-0"
                                        >
                                            compare
                                        </mat-icon>
                                        <div
                                            class="loader-container"
                                            *ngIf="product?.compareLoading"
                                        >
                                            <app-loading></app-loading>
                                        </div>
                                    </button>
                                </div>
                                <div
                                    class=""
                                    [ngClass]="
                                        isGridView == 'true'
                                            ? 'text-center'
                                            : ''
                                    "
                                >
                                    <app-control-add-to-cart
                                        *ngIf="product"
                                        [product]="product"
                                        [isGridView]="isGridView"
                                        [customPadding]="'0 8px'"
                                        [styleCard]="true"
                                        [redirectToProduct]="redirectToProduct"
                                    >
                                    </app-control-add-to-cart>
                                </div>
                            </div>
                        </mat-card-footer>
                    </div>
                </mat-card-content>
            </div>

            <div
                *ngIf="isGridView == 'true'"
                class="d-flex mobile-view border-top p-2 align-items-center w-100 flex-row flex-warp justify-space-between"
            >
                <div class="card-actions d-flex flex-row mx-1">
                    <button
                        (click)="
                            addToFavouriteList(
                                environmentVariables?.PRODUCT_TYPE == 'main'
                                    ? product?.product_variants[0]
                                    : product,
                                environmentVariables?.PRODUCT_TYPE
                            )
                        "
                        class="favorite-icon-container"
                    >
                        <mat-icon
                            [class.left-fav]="lang == 'ar'"
                            [ngClass]="{
                                'wishlist-active':
                                    product?.is_favourite == true ||
                                    product?.product_variants[0]?.is_favourite,
                                'right-5': lang == 'en',
                                'left-5': lang == 'ar',
                                'top-icon':
                                    environmentVariables?.FAVORITE_ICON_POSITION ==
                                    'top'
                            }"
                            class="material-icons favorite pointer favorite-icon-container"
                        >
                            favorite
                        </mat-icon>
                        <div
                            class="loader-container"
                            *ngIf="product?.favouriteLoading"
                        >
                            <app-loading></app-loading>
                        </div>
                    </button>

                    <button
                        *ngIf="!environmentVariables?.DISABLE_COMPARE"
                        (click)="
                            addToCompareList(
                                environmentVariables?.PRODUCT_TYPE == 'main'
                                    ? product?.product_variants[0]
                                    : product
                            )
                        "
                        [disabled]="product?.compareLoading"
                        [style.cursor]="
                            product?.compareLoading ? 'not-allowed' : 'pointer'
                        "
                        title="Compare"
                        class="compare-icon-container"
                    >
                        <mat-icon
                            *ngIf="!product?.compareLoading"
                            [class.compare-active]="
                                product?.is_compare ||
                                product?.product_variants[0]?.is_compare
                            "
                            class="material-icons favorite"
                        >
                            compare
                        </mat-icon>
                        <div
                            class="loader-container"
                            *ngIf="product?.compareLoading"
                        >
                            <app-loading></app-loading>
                        </div>
                    </button>
                </div>
                <div class="text-center">
                    <app-control-add-to-cart
                        *ngIf="product"
                        [product]="product"
                        [styleCard]="true"
                        [isGridView]="isGridView"
                        [redirectToProduct]="redirectToProduct"
                    >
                    </app-control-add-to-cart>
                </div>
            </div>
        </mat-card>
    </div>
</div>
